import React, { useState } from "react";
import "../../../components/table/table.css";
import { FaMinusCircle, FaPlusCircle, FaProjectDiagram } from "react-icons/fa";
import toTitleCase from "../../../lib/titleCase/TitleCase";
import StatusBadge from "./StatusBadge";
import { useNavigate } from "react-router-dom";
import PriorityBadge from "./PriorityBadge";
import TruncateWord from "../../../lib/truncateWords/TruncateWord";

const IssueTracker = ({ last_ten_issues }) => {
  const [showTable, setShowTable] = useState(true);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/support/RaiseIssue");
  };

  return (
    <div className="leave-wrapper">
      <div className="leave-header">
        <div className="leave-title">
          <FaProjectDiagram className="leave-icon" />
          <span>Last 10 Issues</span>
        </div>
        <div className="leave-actions">
          <button className="view-all-btn" onClick={handleClick}>
            View All
          </button>
          <button
            className="icon-toggle-btn"
            onClick={() => setShowTable(!showTable)}
          >
            {showTable ? <FaMinusCircle /> : <FaPlusCircle />}
          </button>
        </div>
      </div>

      {showTable && (
        <div
          className="table-container"
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <table className="leave-table">
            <thead>
              <tr>
                <th className="py-0 px-1">Ticket No</th>
                <th className="py-0 px-1">Project</th>
                <th className="py-0 px-1">Title</th>
                <th className="py-0 px-1">Priority</th>
                <th className="py-0 px-1">Status</th>
              </tr>
            </thead>
            <tbody>
              {(last_ten_issues || []).map((issue) => (
                <tr key={issue.id}>
                  <td>{issue.incident_no}</td>
                  <td>{issue.project__project_name}</td>
                  <td className="text-nowrap">
                    {
                      <TruncateWord
                        strng={toTitleCase(issue.title)}
                        charLimit={10}
                      />
                    }
                  </td>
                  <td>
                    <PriorityBadge
                      priority={toTitleCase(issue.priority_mode)}
                    />
                  </td>
                  <td className="text-nowrap">
                    <StatusBadge status={toTitleCase(issue.status)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ flex: "0 0 10px" }}></div>
        </div>
      )}
    </div>
  );
};

export default IssueTracker;
